// extracted by mini-css-extract-plugin
export var container = "Image-module--container--1D2oO";